<template>
  <main class="task-page">
    <div style="font-weight: bold; font-size: 1.2em; margin:10px">
      {{ $t('taskPage.newTask') }}
    </div>
    <div
      class="container"
    >
      <ItemGrid :normal-columns="1"
                :normal-rows="-1"
                :xs-columns="1"
                :xs-rows="-1"
      >
        <MainInput :text="taskDescription"
                   type="text"
                   name="TaskDescription"
                   style="text-align: left; width: 50%"
                   :placeholder="$t('taskPage.taskdescription')"
                   :is-readonly="false"
                   @value-changed="setTaskDescription"
        />
        <MainInput :text="taskText"
                   type="textarea"
                   name="TaskText"
                   style="height: 160px; text-align: left; width: 50%"
                   :placeholder="$t('taskPage.taskText')"
                   :is-readonly="false"
                   @value-changed="setTaskText"
        />

        <MainInput :selected-item="selectedCustomer"
                   type="selectSearch"
                   :options="eligibleCustomers.Customers"
                   name="Customer"
                   style="text-align: left; width: 50%"
                   :placeholder="$t('taskPage.customer')"
                   :is-readonly="false"
                   @value-changed="setSelectedCustomer"
        />

        <MainInput :selected-item="selectedObject1"
                   type="selectSearch"
                   :options="eligibleObject1s"
                   name="Object"
                   style="text-align: left; width: 50%"
                   :placeholder="$t('taskPage.object1')"
                   :is-readonly="false"
                   :clear-search="clearSearchFlag"
                   @value-changed="setSelectedObject1"
        />

        <MainInput :text="taskCustomT2"
                   type="text"
                   name="TaskCustomT2"
                   style="text-align: left; width: 50%"
                   :placeholder="$t('taskPage.customT2')"
                   :is-readonly="false"
                   @value-changed="setTaskCustomT2"
        />

        <MainInput :selected-item="selectedPriority"
                   type="select"
                   :options="eligiblePriorities"
                   name="Priority"
                   style="text-align: left; width: 50%"
                   :placeholder="$t('taskPage.priority')"
                   :is-readonly="false"
                   @value-changed="setSelectedPriority"
        />

        <div>
          <table class="styled-table">
            <thead>
              <tr>
                <th @click="toggleDocumentTable">
                  {{ isDocumentTableVisible ? '▼' : '▲' }} {{ $t('taskPage.documents') }}
                </th>
                <th />
              </tr>
            </thead>
            <thead>
              <tr>
                <th style="width:10%"
                    @click="setSort({ key: 'Name', reverse: false })"
                >
                  {{ $t('taskPage.documentName') }}
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              <tr v-show="isDocumentTableVisible" class="attachment-row">
                <td colspan="2">
                  <FileDropZone :title="$t('taskPage.attachDocument')"
                                :hint="$t('documentPage.dropFilesHere')"
                                :drop-label="$t('documentPage.dropFilesNow')"
                                :choose-label="$t('documentPage.chooseFiles')"
                                :accepted-types="acceptedFileTypesLabel"
                                :accept="acceptedFileExtensions"
                                @files-selected="selectDocuments"
                  />
                </td>
              </tr>
              <tr v-for="(document, index) in selectedDocuments"
                  v-show="isDocumentTableVisible"
                  :key="index"
                  class="taskRow"
              >
                <td class="tdTask"
                    style="width:90%"
                >
                  {{ document.name }}
                </td>
                <td style="cursor: pointer; text-align: right; padding-right:10px;"
                    @click="removeFileFromSelection(document)"
                >
                  <span class="material-icons">delete</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="isUkEnvironment">
          <table class="styled-table">
            <thead>
              <tr>
                <th @click="toggleReportTable">
                  {{ isReportTableVisible ? '▼' : '▲' }} {{ $t('taskPage.reports') }}
                </th>
                <th />
              </tr>
            </thead>
            <thead>
              <tr>
                <th style="width:10%">{{ $t('taskPage.documentName') }}</th>
                <th />
              </tr>
            </thead>
            <tbody>
              <tr v-show="isReportTableVisible" class="attachment-row">
                <td colspan="2">
                  <FileDropZone :title="$t('taskPage.attachReport')"
                                :hint="$t('documentPage.dropFilesHere')"
                                :drop-label="$t('documentPage.dropFilesNow')"
                                :choose-label="$t('documentPage.chooseFiles')"
                                :accepted-types="acceptedFileTypesLabel"
                                :accept="acceptedFileExtensions"
                                @files-selected="selectReports"
                  />
                </td>
              </tr>
              <tr v-for="(report, index) in selectedReports"
                  v-show="isReportTableVisible"
                  :key="index"
                  class="taskRow"
              >
                <td class="tdTask" style="width:90%">{{ report.name }}</td>
                <td style="cursor: pointer; text-align: right; padding-right:10px;"
                    @click="removeReportFromSelection(report)"
                >
                  <span class="material-icons">delete</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ItemGrid>

      <ItemGrid :normal-columns="4"
                :normal-rows="-1"
                :xs-columns="1"
                :xs-rows="-1"
      >
        <form @submit.prevent="postNewTask">
          <MainButton :button-text="$t(`taskPage.createTask`)"
                      type="submit"
                      style="height:50px; margin-bottom:1rem;"
          />
        </form>
        <MainButton :button-text="$t(`taskPage.cancel`)"
                    type="button"
                    style="height:50px;  margin-bottom:1rem;"
                    @click="cancel"
        />
      </ItemGrid>
    </div>
  </main>
</template>
<script setup>

import ItemGrid from '@/components/grid/ItemGrid.vue'
import MainInput from '@/components/inputs/MainInput.vue'
import MainButton from '@/components/buttons/MainButton.vue'
import FileDropZone from '@/components/inputs/FileDropZone.vue'
import router from '@/router'
import { PostTask } from '@/api/task.js'
import { PostDocument } from '@/api/document.js'
import { ref, onMounted, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { useToast } from 'vue-toastification'
import i18n from '@/locales/i18n'
import { isReportEnvironment } from '@/utils/environment.js'
const toast = useToast()
const store = useStore()
const reportCategory = 'REPORT'
const isUkEnvironment = isReportEnvironment()

const eligibleCustomers = computed(() => store.state.account.me)
const eligibleObject1s = computed(() => store.state.object1.object1s)
const allowedExtensions = computed(() => store.state.document.allowedExtensions)
const acceptedFileExtensions = computed(() => allowedExtensions.value.map(extension => `.${extension}`).join(','))
const acceptedFileTypesLabel = computed(() => allowedExtensions.value.length > 0
  ? i18n.global.t('documentPage.allowedFileTypes', { types: allowedExtensions.value.join(', ') })
  : '')
onMounted(async () => {
  store.dispatch('document/getAllowedFileExtensions')
  store.dispatch('account/getMe')
  store.dispatch('object1/getBaseData')
})

// The priority we send to the API, needs to be environment decided, not based on language selection

const eligiblePriorities = computed(() => ({
  Low: i18n.global.t('taskPage.priorityLow'),
  Normal: i18n.global.t('taskPage.priorityNormal'),
  High: i18n.global.t('taskPage.priorityHigh')
}))
const priorityMapping = {
  UK: { Low: 'Low', Normal: 'Normal', High: 'High' },
  SE: { Low: 'Låg', Normal: 'Normal', High: 'Akut' },
  DK: { Low: 'Lav', Normal: 'Normal', High: 'Akut' },
  NO: { Low: 'Låg', Normal: 'Normal', High: 'Akut' },
  NL: { Low: 'Low', Normal: 'Normal', High: 'High' }
}

const currentEnv = window.apiConfig.ENV || 'UK'
const getBackendPriority = () => {
  const environmentMapping = priorityMapping[currentEnv] || priorityMapping.UK
  return environmentMapping[selectedPriority.value] || 'Normal' // Default to 'Normal'
}
const selectedCustomer = ref('')
const setSelectedCustomer = (value) => {
  selectedCustomer.value = value
}

const taskText = ref('')
const setTaskText = (e) => {
  taskText.value = e.target.value
}

const selectedPriority = ref('Normal')
const setSelectedPriority = (key) => {
  selectedPriority.value = key
}

const taskCustomT2 = ref('')
const setTaskCustomT2 = (e) => {
  taskCustomT2.value = e.target.value
}

const taskDescription = ref('')
const setTaskDescription = (e) => {
  taskDescription.value = e.target.value
}

const selectedObject1 = ref('')
const setSelectedObject1 = (value) => {
  selectedObject1.value = value
}

const selectedDocuments = ref([])
function selectDocuments (files) {
  addSelectedFiles(files, selectedDocuments.value)
}

const selectedReports = ref([])
function selectReports (files) {
  addSelectedFiles(files, selectedReports.value)
}

function addSelectedFiles (files, selection) {
  const maxSizeInBytes = 10 * 1024 * 1024 // maximum size limit (e.g., 10 MB)

  const newFiles = Array.from(files)
  const normalizedAllowedExtensions = allowedExtensions.value.map(extension => extension.toLowerCase())

  for (const file of newFiles) {
    const fileParts = file.name.split('.')
    const fileExtension = fileParts[fileParts.length - 1].toLowerCase()
    if (normalizedAllowedExtensions.indexOf(fileExtension) === -1) {
      toast.info(i18n.global.t('documentPage.fileTypesNotAllowed') + allowedExtensions.value.join(', '))
      continue
    }

    if (file.size > maxSizeInBytes) {
      toast.info(
        `${file.name} exceeds the maximum allowed size of ${maxSizeInBytes / (1024 * 1024)} MB`
      )
      // Skip files that exceed the maximum size
      continue
    }

    // Check if the file is not already in the selectedDocuments array
    if (!selection.some((doc) => doc.name === file.name)) {
      selection.push(file)
    }
  }
}

async function postNewTask () {
  // console.log(selectedCustomer.value)
  if (!selectedCustomer.value) {
    toast.error(i18n.global.t('taskPage.selectACustomer'))
    return
  }
  if (!selectedObject1.value) {
    toast.error(i18n.global.t('taskPage.selectAnObject'))
    return
  }
  if (!taskCustomT2.value) {
    toast.error(i18n.global.t('taskPage.setCustomT2BeforePosting'))
    return
  }

  if (!taskText.value) {
    toast.error(i18n.global.t('taskPage.inputTaskField'))
    return
  }

  if (taskCustomT2.value.length > 128) {
    toast.error(i18n.global.t('taskPage.customT2MaxLengthExceeded'))
    return
  }

  const json = {
    CustomerId: selectedCustomer.value.Id,
    Text: taskText.value,
    CustomT2: taskCustomT2.value,
    Priority: getBackendPriority(),
    UserProperties: {
      10063: taskDescription.value
    }
  }
  if (selectedObject1.value) {
    json.ObjectId = selectedObject1.value.Id
  }

  if (selectedDocuments.value && selectedDocuments.value.length > 0) {
    let allFilesAllowed = true
    for (const file of selectedDocuments.value) {
      const fileParts = file.name.split('.')
      const fileExtension = fileParts[fileParts.length - 1]
      if (allowedExtensions.value.indexOf(fileExtension) === -1) {
        allFilesAllowed = false
        break
      }
    }

    if (!allFilesAllowed) {
      toast.info(i18n.global.t('documentPage.fileTypesNotAllowed') + allowedExtensions.value.join(', '))
      return
    }
  }

  if (!areFilesAllowed(selectedReports.value)) {
    toast.info(i18n.global.t('documentPage.fileTypesNotAllowed') + allowedExtensions.value.join(', '))
    return
  }

  try {
    const result = await PostTask(json)
    // console.log(result)
    if (result.status === 200) {
      if (selectedDocuments.value && selectedDocuments.value.length > 0) {
        const formdata = new FormData()

        let allFilesAllowed = true
        for (const file of selectedDocuments.value) {
          const fileParts = file.name.split('.')
          const fileExtension = fileParts[fileParts.length - 1]
          if (allowedExtensions.value.indexOf(fileExtension) === -1) {
            allFilesAllowed = false
            break
          }
        }

        if (!allFilesAllowed) {
          toast.info(i18n.global.t('documentPage.fileTypesNotAllowed') + allowedExtensions.value.join(', '))
          return
        }

        for (const file of selectedDocuments.value) {
          formdata.append('file', file)
        }
        try {
          await PostDocument('task', result.data.Id, formdata)
          // console.log(postResponse)
        } catch (e) {
          toast.warning(e.message)
          router.push('/tasks/' + result.data.Id)
        }
      }
      if (selectedReports.value.length > 0) {
        const reportFormdata = new FormData()
        for (const file of selectedReports.value) {
          reportFormdata.append('file', file)
        }
        try {
          await PostDocument('task', result.data.Id, reportFormdata, reportCategory)
        } catch (e) {
          toast.warning(e.message)
          router.push('/tasks/' + result.data.Id)
        }
      }
      toast.success(i18n.global.t('taskPage.taskCreated'))
      router.push('/tasks/' + result.data.Id)
    } else {
      toast.error(i18n.global.t('taskPage.couldNotCreateTask'))
    }
  } catch (e) {
    // console.log(e)
    toast.error(i18n.global.t('taskPage.couldNotCreateTask'))
  }
}
function cancel () {
  router.push('/tasks')
}
watch(selectedCustomer, (newCustomer) => {
  if (newCustomer == null) {
    triggerClearSearch()
    selectedObject1.value = null // Clear the selected object

    store.dispatch('object1/getBaseData')
    return
  }
  const newCustomerId = parseInt(newCustomer.Id, 10) // Ensure the customer ID is a number

  if (newCustomerId) {
    // Dispatch to filter the object options based on the selected customer
    store.dispatch('object1/getObject1sByCustomer', newCustomerId)

    // Check if the selected object is still valid for the new customer
    if (!eligibleObject1s.value.some((obj) => obj.Id === selectedObject1.value)) {
      // If the selected object doesn't belong to the new customer, clear it
      selectedObject1.value = null // Clear the selected object

      triggerClearSearch()
    }
  } else {
    // Reset the object options if no customer is selected
    eligibleObject1s.value = store.state.object1.object1s
  }
})

const clearSearchFlag = ref(false)
const triggerClearSearch = () => {
  clearSearchFlag.value = true // Trigger the clear
  setTimeout(() => {
    clearSearchFlag.value = false // Reset the flag to allow future triggers
  }, 0) // Ensure the prop changes back quickly
}
const isDocumentTableVisible = ref(true)
const toggleDocumentTable = () => {
  isDocumentTableVisible.value = !isDocumentTableVisible.value
}
const removeFileFromSelection = (documentToRemove) => {
  selectedDocuments.value = selectedDocuments.value.filter((doc) => doc !== documentToRemove)
}
const isReportTableVisible = ref(true)
const toggleReportTable = () => {
  isReportTableVisible.value = !isReportTableVisible.value
}
const removeReportFromSelection = (reportToRemove) => {
  selectedReports.value = selectedReports.value.filter((report) => report !== reportToRemove)
}

const areFilesAllowed = (files) => files.every(file => {
  const fileParts = file.name.split('.')
  const normalizedAllowedExtensions = allowedExtensions.value.map(extension => extension.toLowerCase())
  return normalizedAllowedExtensions.indexOf(fileParts[fileParts.length - 1].toLowerCase()) !== -1
})

</script>

<style lang="scss" scoped>
.task-page {
  height: 100%;
  overflow: scroll;
  background: var(--mainBackground);
  .container{
    padding: 1rem;
  }
}

.styled-table {
  table-layout: fixed;
  border-collapse: collapse;
  margin: 25px 0;
  font-size: 0.9em;
  font-family: 'Lexend', sans-serif;
  width: 100%;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
}

.styled-table thead tr {
  background-color: var(--mainBlue);
  color: white;
  text-align: left;
  cursor: pointer; /* Add this line to set the cursor to pointer on hover */
}

.styled-table th {
  padding: 12px 15px;
  text-align: left;
}

.styled-table tbody tr {
  border-bottom: 1px solid lightgrey;
  background-color: white;
  color: black;
}

.attachment-row td {
  padding: 12px;
  background: white;
}

.styled-table tbody tr:nth-of-type(4n-1),
.styled-table tbody tr:nth-of-type(4n) {
  background-color: var(--alternatingListColor);
  color: black;
}
.taskRow{
  border-bottom: 1px solid lightgrey;
  background-color: white;
  color: black;
  height: 20px;

  .header{
    font-weight: bold;
  }
}

.taskRow:nth-of-type(2n) {
  background-color: var(--alternatingListColor);
  color: black;
}

.taskRow:last-of-type {
  border-bottom: 3px solid var(--mainBlue);
}

.tdTask {
  padding: 10px 15px;
  text-align: left;
  transition: padding 0.4s ease;

}

.select-container {
  position: relative;
}

.search-input {
  width: 100%;
  margin-bottom: 5px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
}
</style>
